import { render } from "./cardsprods2.vue?vue&type=template&id=67c6cd32&scoped=true"
import script from "./cardsprods2.vue?vue&type=script&lang=js"
export * from "./cardsprods2.vue?vue&type=script&lang=js"

import "./cardsprods2.vue?vue&type=style&index=0&id=67c6cd32&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c6cd32"]])

export default __exports__